var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M14 34.5L42 34.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 23",
    cx: 33.5,
    cy: 26,
    rx: 2.5,
    ry: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 24",
    cx: 21.5,
    cy: 26,
    rx: 2.5,
    ry: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M15 18C16.375 16.6667 19.125 16.6667 21.1875 18C22.8375 19.0667 23.625 19.6111 25 20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 54",
    d: "M31 18.5C31 17 32.3333 15 35 15C36.6933 15 37.849 16.0081 38.4671 17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubt);
export default __webpack_public_path__ + "static/media/Doubt.399f155260328fe73a51dbfb8e262d7c.svg";
export { ForwardRef as ReactComponent };